import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { FullcircleSyncMode } from '@/enums/FullcircleSyncMode';

export default class FullcirclePosApiService extends ApiService<any> {
  constructor() {
    super('fullcircle-pos');
  }

  public syncMenu(payload: { venue: string; mode: FullcircleSyncMode }): AxiosPromise<{ syncJobId: string }> {
    return axios.post(`${this.getBaseUrl()}/menu/sync`, {
      mode: payload.mode,
      venue: payload.venue,
    });
  }
}
